import { useColorMode } from '@chakra-ui/color-mode'
import { images } from 'theme'

const useLogoColor = (): any => {
  const { colorMode } = useColorMode()
  return colorMode === 'light' ? images.logo_black : images.logo_white
}

export default useLogoColor
